// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'hieroglyphics-initiative',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'THE HIEROGLYPHICS INITIATIVE',
  heroHeadingTwo: 'MACHINE LEARNING RESEARCH PROJECT',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle', 'Google Zoo'],
    },
    {
      title: 'CLIENT',
      items: ['Ubisoft'],
    },
    {
      title: 'TECHNOLOGY',
      items: ['TensorFlow', 'Firebase', 'Google Cloud Platform'],
    },
  ],
  heading: 'MACHINE LEARNING RESEARCH PROJECT TO DEVELOP NEW TOOLS FOR EGYPTOLOGISTS',
  challengeImg: 'challenge.jpg',
  challenge: ['Can we use machine learning to help Egyptologists translate hieroglyphics?'],
  solutionImg: 'solution.png',
  solution: [
    'Working in collaboration with Ubisoft and Google, we are developing  an open source project that aims to revolutionise the study and translation of hieroglyphs.',
    `The initial phases have involved gathering the resources and building the partnerships we will need for a successful project. For example, in order to train a machine learning model to recognise almost 1000 different hieroglyphs, we required over 40,000 sample images. To generate these we created a drawing tool to crowdsource the images from thousands of Assassin’s Creed: Origins fans.`,
    'We are currently in alpha testing of our first translation tools with a group of collaborators from the academic community, and aim to release the technology and data as an open source project by the middle of the year.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: 'DRAWING TOOL',
      content: ['WITH THE HELP OF FANS OF ASSASSIN’S CREED: ORIGINS, OUR DRAWING TOOL GENERATED OVER 65,000 IMAGES.'],
    },
    {
      img: 'callout_2.jpg',
      title: 'IDENTIFYING GLYPHS',
      content: ['WE’RE USING A COMBINATION OF COMPUTER VISION TECHNIQUES AND GOOGLE TENSORFLOW TO CAPTURE AND IDENTIFY GLYPH SEQUENCES.'],
    },
    {
      img: 'callout_3.jpg',
      title: 'MAJOR LAUNCH',
      content: ['THE PROJECT WAS LAUNCHED IN SEPTEMBER 2017 AT THE BRITISH MUSEUM.'],
    },
  ],
  nextCaseStudy: 'armani',
};

export default casestudyData;
